<template>
  <div id="landing" class="container-fluid menu-container">
    <div class="row wrap justify-content-center">
      <menu-tile :to="{name: 'event_list'}" image="static/landing-icons/event.svg">
        Események
      </menu-tile>

      <menu-tile :to="{name: 'scheduled_event_list'}" image="static/landing-icons/scheduled_event.svg" :disabled="!canUseScheduledEvents">
        Ütemezett események
      </menu-tile>

      <menu-tile :to="{name: 'event_templates_list'}" image="static/landing-icons/event_template.svg" :disabled="!canUseScheduledEvents">
        Esemény sablonok
      </menu-tile>

      <menu-tile :to="{name: 'partner_list'}" image="static/landing-icons/partner.svg" :disabled="!canUsePartners">
        Partnerek
      </menu-tile>

      <menu-tile :to="{name: 'user_list'}" image="static/landing-icons/user.svg" :disabled="!canUseUsers">
        Felhasználók
      </menu-tile>

      <menu-tile :to="{name: 'group_list'}" image="static/landing-icons/user_group.svg" :disabled="!canUseGroups">
        Csoportok
      </menu-tile>

      <menu-tile :to="{name: 'error_report_list'}" image="static/landing-icons/error_report.svg">
        Adatvédelmi incidensbejelentő
      </menu-tile>

      <menu-tile :to="{name: 'documents'}" image="static/landing-icons/dokument.svg">
        Dokumentumok
      </menu-tile>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

import MenuTile from '@/components/MenuTile'

export default {
  components: {
    MenuTile
  },

  computed: {
    ...mapGetters({
      hasToken: 'auth/hasToken',
      getToken: 'auth/getToken',
      user: 'userDetails/getUserProfile'
    }),

    canUseScheduledEvents () {
      return this.user && this.user.permissions.includes('events.can_use_scheduled_events')
    },

    canUsePartners () {
      return this.user && this.user.permissions.includes('partners.can_use_partners')
    },

    canUseUsers () {
      return this.user && this.user.permissions.includes('users.can_use_users')
    },

    canUseGroups () {
      return this.user && this.user.permissions.includes('users.can_use_groups')
    }
  },

  methods: {
    ...mapMutations({
      resetPagination: 'pagination/resetPagination',
      resetSearchBox: 'searchBox/resetSearchBox'
    })
  },

  created () {
    this.resetPagination()
    this.resetSearchBox()
    if (!this.hasToken) {
      this.$router.push({name: 'login'})
    }
  }
}
</script>

<style lang="styl" scoped>
  @import "../assets/stylus/menu.styl";
</style>



// WEBPACK FOOTER //
// src/views/landing.vue